export default "__VITE_ASSET__ZOcuCLCl__"